const EMAIL_FILTERS = [
  /^([a-z0-9]([a-z0-9_.\-+'=])*)?[a-z0-9]@[a-z0-9][a-z0-9\-.]*[a-z0-9]\.[a-z]{2,7}$/,
];

export const validateEmail = value => {
  for (const regExp of EMAIL_FILTERS) if (regExp.test(value)) return true;
  return false;
};
